<template>
    <v-container id="page-container" fluid>
        <!-- <div> d{{ page }}d</div>
        <div> d{{ selected }}d</div>
        <div> d{{ contentViewMode }}d</div>
        <div> d{{ componentParamInput }}d</div>
        <div> d{{ breadcrumbs }}d</div> -->
        <!-- {{pageSections.length}} -->

        <!-- NAVIGATION DRAWER -->
        <v-navigation-drawer id="left-navigation-drawer" fixed dense app :clipped="$vuetify.breakpoint.mdAndUp"
            :temporary="$vuetify.breakpoint.smAndDown" v-model="drawer" v-if='pageSections.length > 1'>
            <v-card flat height='146px'>
                <v-img src="./img/valesco_logo.png" height="150" contain></v-img>
            </v-card>
            <v-list shaped dense nav>
                <v-list-item-group v-model="selected" mandatory active-class="custom-color--text">
                    <div style="padding:0px;margin:0px" class="section-content" v-for="(section, index) in pageSections"
                        :key="section.cod">
                        <!-- Heading section-->
                        <v-layout row v-if="section.heading" align-center :key="section.heading">
                            <v-flex xs6>
                                <v-subheader v-if="section.heading">
                                    {{ section.heading }}
                                </v-subheader>
                            </v-flex>
                            <v-flex xs6 class="text-xs-center">
                                <a href="#!" class="body-2 black--text">EDIT</a>
                            </v-flex>
                        </v-layout>

                        <!-- Section with subsections-->
                        <v-list-group v-else-if="section.section_list && section.section_list.length > 1"
                            v-model="section.model" :key="section.cod"
                            :prepend-icon="section.model ? section.icon : section['icon-alt']" append-icon="">
                            <v-list-item slot="activator">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ section["name"] }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-for="(subSection, i) in section.section_list" :key="i">
                                <v-list-item-action v-if="subSection.icon">
                                    <v-icon>{{ subSection.icon }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ subSection["name"] }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-group>

                        <!-- Section with no child sections -->
                        <v-list-item v-else :key="section.name" :to="getItemLink(index)" @click="closeDrawerOnMobile">
                            <template v-slot:default="{ active, toggle }">
                                <v-list-item-action>
                                    <v-icon>cloud</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ section["name"] }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-list-item>
                        <v-divider v-if="index + 1 < pageSections.length" :key="index"></v-divider>
                    </div>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>

        <v-btn v-if="showMobileCorpusDrawerButton" class="corpus-drawer-toggle hidden-md-and-up" fab dark small
            :aria-label="drawer ? 'Cerrar menú del corpus' : 'Abrir menú del corpus'" @click.stop="toggleCorpusDrawer">
            <v-icon dark>{{ drawer ? 'close' : 'menu_open' }}</v-icon>
        </v-btn>

        <!-- SUBSECTION CONTAINER -->
        <v-main id="subsection-main-container" style="padding:0">
            <!-- --{{pageSections[selected]["cod"]}}-{{contentViewMode}}--
            d{{this.$route.params.page}}d -->
            <v-container class="pa-0" v-if="(pageSections[selected] || pageSections.length === 1) && loading">
                <v-row class="loading-page" v-if="loading" no-gutters justify="center" align-self="center"
                    align="center">
                    <v-col justify="center" cols="auto">
                        <v-progress-circular indeterminate :size="100" :width="8"></v-progress-circular>
                    </v-col>
                </v-row>
            </v-container>

            <v-container class="pa-0" v-if="(pageSections[selected] || pageSections.length === 1) && !loading">
                <!--                    <v-layout justify-left align-left>
                                            <v-card-title class="headline section_title">{{ pageSections[selected]["name"] }}</v-card-title>
                                        </v-layout>-->

                <!--CARROUSSEL-->
                <v-container v-if="this.$route.params && this.$route.params.page === 'cod_jtvjm74bvgkjtlhlx59'"
                    class="row-padding">
                    <v-row no-gutters justify="center">
                        <template>
                            <v-carousel style="margin-top:20px;margin-bottom:20px; max-width:1024px;" height="400"
                                continuous cycle hide-delimiter-background show-arrows-on-hover>
                                <v-carousel-item v-for="(slide, i) in slides" :key="i" :src="slide.src">
                                </v-carousel-item>
                            </v-carousel>
                        </template>
                    </v-row>
                </v-container>


                <!-- BREADCRUMB -->
                <v-container id="breadcrumb-section" v-if="pageSections[selected]['cod'] === 'cod_m5em4hajg5ljtpxzuc1'"
                    class="row-padding">
                    <breadcrumb-element :items="breadcrumbs" @clicked="buildBreadcrumbs"></breadcrumb-element>
                </v-container>

                <!-- CONVERSATION -->
                <div v-if="pageSections[selected]['cod'] === 'cod_m5em4hajg5ljtpxzuc1' && contentViewMode === 'conversations'"
                    class="section-content">
                    <conversation-explorer @clicked="buildBreadcrumbs"></conversation-explorer>
                </div>
                <div v-else-if="pageSections[selected]['cod'] === 'cod_m5em4hajg5ljtpxzuc1' && contentViewMode === 'conversation_advanced_audio'"
                    class="section-content">
                    <conversation-advanced-audio :code="componentParamInput"
                        @clicked="buildBreadcrumbs"></conversation-advanced-audio>
                </div>
                <div v-else-if="pageSections[selected]['cod'] === 'cod_m5em4hajg5ljtpxzuc1' && contentViewMode === 'conversation_details'"
                    class="section-content">
                    <conversation-details :code="componentParamInput"
                        @clicked="buildBreadcrumbs"></conversation-details>
                </div>
                <div v-else-if="pageSections[selected]['cod'] === 'cod_m5em4hajg5ljtpxzuc1' && contentViewMode === 'annotation_details'"
                    class="section-content">
                    <annotation-details :code="componentParamInput" @clicked="buildBreadcrumbs"></annotation-details>
                </div>
                <div v-else-if="pageSections[selected]['cod'] === 'cod_m5em4hajg5ljtpxzuc1' && contentViewMode === 'speech_details'"
                    class="section-content">
                    <speech-details :code="componentParamInput" @clicked="buildBreadcrumbs"></speech-details>
                </div>
                <div v-else-if="pageSections[selected]['cod'] === 'cod_m5em4hajg5ljtpxzuc1' && contentViewMode === 'dialog_details'"
                    class="section-content">
                    <dialog-details :code="componentParamInput" @clicked="buildBreadcrumbs"></dialog-details>
                </div>
                <div v-else-if="pageSections[selected]['cod'] === 'cod_m5em4hajg5ljtpxzuc1' && contentViewMode === 'intervention_details'"
                    class="section-content">
                    <intervention-details :code="componentParamInput"
                        @clicked="buildBreadcrumbs"></intervention-details>
                </div>
                <div v-else-if="pageSections[selected]['cod'] === 'cod_m5em4hajg5ljtpxzuc1' && contentViewMode === 'act_details'"
                    class="section-content">
                    <act-details :code="componentParamInput" @clicked="buildBreadcrumbs"></act-details>
                </div>
                <div v-else-if="pageSections[selected]['cod'] === 'cod_m5em4hajg5ljtpxzuc1' && contentViewMode === 'subact_details'"
                    class="section-content">
                    <subact-details :code="componentParamInput" @clicked="buildBreadcrumbs"></subact-details>
                </div>
                <div v-else-if="pageSections[selected]['cod'] === 'cod_m5em4hajg5ljtpxzuc1' && contentViewMode === 'token_details'"
                    class="section-content">
                    <token-details :code="componentParamInput" @clicked="buildBreadcrumbs"></token-details>
                </div>

                <!-- CONVERSATION SEARCH -->
                <div v-else-if="pageSections[selected]['cod'] === 'cod_fa393ih5l4jx9zssv7'" class="section-content">
                    <advanced-search :code="componentParamInput" @clicked="buildBreadcrumbs"></advanced-search>
                </div>

                <!-- CONVERSATION CHRONOLOGIC SEARCH -->
                <div v-else-if="pageSections[selected]['cod'] === 'cod_b18socdouulm39l3ib'" class="section-content">
                    <chronologic-search :code="componentParamInput" @clicked="buildBreadcrumbs"></chronologic-search>
                </div>

                <!-- DOCUMENT -->
                <div v-if="pageSections[selected]['cod'] === 'cod_m5em4hajg5ljtpxzucd' && contentViewMode === 'letters'"
                    class="section-content">
                    <letter-explorer @clicked="buildBreadcrumbs"></letter-explorer>
                </div>
                <div v-else-if="pageSections[selected]['cod'] === 'cod_m5em4hajg5ljtpxzucd' && contentViewMode === 'view_letter'"
                    class="section-content">
                    <letter-viewer :code="componentParamInput" @clicked="buildBreadcrumbs"></letter-viewer>
                </div>

                <!-- DOCUMENT SEARCH -->
                <div v-else-if="pageSections[selected]['cod'] === 'cod_fa393ih5l4jx9zssv9'" class="view_search">
                    <letter-search :code="componentParamInput" @clicked="buildBreadcrumbs"></letter-search>
                </div>

                <!-- MEMBER -->
                <div v-else-if="pageSections[selected]['cod'] === 'cod_b8p5565dfbjjtpkvzjm'" class="section-content">
                    <member-list :code="componentParamInput" @clicked="buildBreadcrumbs"></member-list>
                </div>

                <!-- OTHER SECTIONS -->
                <div v-else class="section-content" v-html="pageSections[selected]['html_contents']"> </div>
            </v-container>
        </v-main>
    </v-container>
</template>
<script>
import api from '@/restApi';
import {
    // Conversation
    ConversationExplorer,
    ConversationAdvancedAudio,
    ConversationDetails,
    AnnotationDetails,
    SpeechDetails,
    DialogDetails,
    InterventionDetails,
    ActDetails,
    SubactDetails,
    TokenDetails,
    AdvancedSearch,
    ChronologicSearch,

    // Letter
    LetterExplorer,
    LetterViewer,
    LetterSearch,

    // Member
    MemberList,
    Breadcrumb
} from '@/components';
export default {
    name: 'web-page',
    bodyClass: 'default-page',
    data() {
        return {
            loading: true,
            colors: [
                'indigo',
                'warning',
                'pink darken-2',
                'red lighten-1',
                'deep-purple accent-4'
            ],
            slides: [
                {
                    src: './img/carousel/carousel_sample_0.jpg'
                },
                {
                    src: './img/carousel/carousel_sample_1.jpg'
                },
                {
                    src: './img/carousel/carousel_sample_2.jpg'
                },
                {
                    src: './img/carousel/carousel_sample_3.jpg'
                }
            ],
            breadcrumbs: [],
            breadcrumbsMap: {
                conversations: {
                    label: 'Conversaciones',
                    disabled: false,
                    icon: "mdi-format-list-bulleted-type",
                    view: "conversations",
                    parent: null
                },
                conversation_details: {
                    label: 'Conversación',
                    disabled: false,
                    icon: "mdi-access-point",
                    view: "conversation_details",
                    parent: "conversations"
                },
                conversation_advanced_audio: {
                    label: 'Reproducción avanzada',
                    disabled: false,
                    icon: "volume_up",
                    view: "conversation_advanced_audio",
                    parent: "conversations"
                },
                annotation_details: {
                    label: 'Grupo entonativo',
                    disabled: false,
                    icon: "mdi-google-circles-extended",
                    view: "annotation_details",
                    parent: "conversations"
                },
                speech_details: {
                    label: 'Discurso',
                    disabled: false,
                    icon: "mdi-text-to-speech",
                    view: "speech_details",
                    parent: "conversation_details"
                },
                dialog_details: {
                    label: 'Diálogo',
                    disabled: false,
                    icon: "g_translate",
                    view: "dialog_details",
                    parent: "speech_details"
                },
                intervention_details: {
                    label: 'Intervención',
                    disabled: false,
                    icon: "record_voice_over",
                    view: "intervention_details",
                    parent: "dialog_details"
                },
                act_details: {
                    label: 'Acto',
                    disabled: false,
                    icon: "mdi-hexagon",
                    view: "act_details",
                    parent: "intervention_details"
                },
                subact_details: {
                    label: 'Subacto',
                    disabled: false,
                    icon: "mdi-hexagon-multiple",
                    view: "subact_details",
                    parent: "act_details"
                },
                token_details: {
                    label: 'Palabra',
                    disabled: false,
                    icon: "font_download",
                    view: "token_details",
                    parent: "subact_details"
                },
                letters: {
                    label: 'Cartas',
                    disabled: false,
                    icon: "mdi-format-list-bulleted-type",
                    view: "letters",
                    parent: "conversations"
                },
                view_letter: {
                    label: 'Carta',
                    disabled: false,
                    icon: "mdi-access-point",
                    view: "letter_viewer",
                    parent: null
                }
            },
            // Page content management
            contentViewMode: "",
            componentParamInput: "",
            contentViewAction: "",
            // Navigation drawer
            drawer: true,
            // Server data
            page: null,
            parentSection: null,
            pageSections: [],
            selectedSection: null,
            selected: null
        };
    },
    props: {
        sideBarVisible: {
            type: Boolean,
            default() {
                return true;
            }
        }
    },
    beforeMount() {
        //            alert("CHILD INIT:" + this.sideBarVisible)
        this.drawer = this.$vuetify.breakpoint.mdAndUp ? this.sideBarVisible : false; // save props data to itself's data and deal with it
    },
    created: function () {
        const params = this.$route.params;

        //            alert(JSON.stringify(params));

        if (params.view) {
            this.contentViewMode = params.view;
        }
        if (params.item_code) {
            this.componentParamInput = this.$mout.lang.clone(params.item_code);
        }

        if (this.contentViewMode) {
            this.buildBreadcrumbs(this.contentViewMode, this.componentParamInput);
        }

        this.refreshSections(params.page, params.section, params.subsection);

        // this.breadcrumbs = [this.breadcrumbsMap["conversations"]];
    },
    watch: {
        '$route.params': function (params) {
            // console.log("ROUTE PARAMS:", JSON.stringify(params));

            if (!this.parentSection) {
                this.contentViewMode = null;
                this.componentParamInput = null;
            }

            if (params.view) {
                this.contentViewMode = params.view;
            }

            if (params.item_code) {
                this.componentParamInput = this.$mout.lang.clone(params.item_code);
            }

            if (this.contentViewMode) {
                this.buildBreadcrumbs(this.contentViewMode, this.componentParamInput);
            }
            //                
            // If section is the search corpus page
            //                if (params.section === "cod_m5em4hajg5ljtpxzuc1") {
            //                    // Use the router to redirect
            //                    return this.$router.push("/corpus_search");
            //                }

            this.refreshSections(params.page, params.section, params.subsection);
        },
        sideBarVisible: function () {
            //                alert("CHILD WATCH: " + this.sideBarVisible)
            if (this.$vuetify.breakpoint.mdAndUp) {
                this.drawer = this.sideBarVisible;
            }
        },
        selected: function (index) {
            // this.breadcrumbs = [this.breadcrumbsMap[this.contentViewMode]];
        }
    },
    computed: {
        isCorpusPage() {
            return this.page && this.page.cod === "cod_hj3y7hwvuuajtlkq0ik";
        },
        showMobileCorpusDrawerButton() {
            return this.isCorpusPage && this.pageSections.length > 1;
        }
    },
    methods: {
        toggleCorpusDrawer() {
            this.drawer = !this.drawer;
        },
        closeDrawerOnMobile() {
            if (this.$vuetify.breakpoint.smAndDown) {
                this.drawer = false;
            }
        },
        redirectToHome() {
            this.$router.replace("/").catch(() => { });
        },
        async redirectEmptyCorpusSectionToFirstChild(page, section, subsection) {
            if (subsection || page !== "cod_hj3y7hwvuuajtlkq0ik" || !this.selectedSection) {
                return false;
            }

            if ((this.selectedSection["html_contents"] || "").trim()) {
                return false;
            }

            const queryString = "is_published=true&section.cod=" + section + "&sort={\"field\":\"order\",\"dir\":\"asc\"}";
            const childSections = await api.getAllItems("section", queryString);

            if (childSections instanceof Error || childSections.length === 0) {
                return false;
            }

            this.$router.replace({
                name: "pages2",
                params: {
                    page: page,
                    section: section,
                    subsection: childSections[0]["cod"]
                }
            }).catch(() => { });

            return true;
        },
        getItemLink(index) {
            var link;

            link = '/pages/' + this.page['cod'] + "/" + this.pageSections[index]['cod'];
            if (this.parentSection) {
                link = '/pages/' + this.page['cod'] + "/" + this.parentSection['cod'] + '/' + this.pageSections[index]['cod'];

                if (this.pageSections[index]["cod"] === "cod_m5em4hajg5ljtpxzuc1") {
                    link += "/conversations"
                }else{
                    link += "/letters"
                }
            }

            return link;
        },
        async buildBreadcrumbs(viewMode, itemCode) {
            var currentView;
            var breadcrumbs;
            var i;

            const itemConversationCode = itemCode ? itemCode.substring(0, itemCode.indexOf("-")) : null;

            breadcrumbs = [];

            const breadcrumbsMap = await this.$mout.array.toLookup(this.breadcrumbs, "view");

            i = 0;
            currentView = viewMode;
            do {
                // Save guard in case build fails
                if (i > 10) {
                    return;
                }

                i++;
                var currentBreadcrumb;

                if (breadcrumbsMap[currentView]) {
                    const parameter = breadcrumbsMap[currentView]["parameter"];

                    // If breadcrumb exists and it belongs a conversation
                    if (parameter) {
                        const breadcrumbsMapConversationCode = parameter.indexOf("-") >= 0 ? parameter.substring(0, parameter.indexOf("-")) : parameter.substring(0, parameter.length);
                        
                        // If breadcrumb exists and is bit the asked view
                        if (currentView != viewMode && (!itemConversationCode || itemConversationCode === breadcrumbsMapConversationCode)) {
                            currentBreadcrumb = breadcrumbsMap[currentView];
                        }
                    } else {
                        currentBreadcrumb = breadcrumbsMap[currentView];
                    }
                }

                if (!currentBreadcrumb) {
                    currentBreadcrumb = this.$mout.lang.clone(this.breadcrumbsMap[currentView]);

                    currentBreadcrumb["parameter"] = itemCode;
                }

                //         //                        self.breadcrumbsMap[self.contentViewMode]["disabled"] = true;
                // Add the current view breadcrumb
                breadcrumbs.unshift(currentBreadcrumb)

                // Get current view parent
                currentView = currentBreadcrumb["parent"]
            } while (currentView); // Repeat while parent exists.

            this.breadcrumbs = breadcrumbs;
        },
        async refreshSections(page, section, subsection) {
            var queryString;

            this.loading = true;

            // Selected page is corpus page
            if (!subsection) {
                queryString = "is_published=true&page.cod=" + page + "&populate=page.cod,page.name,page.description&sort={\"field\":\"order\",\"dir\":\"asc\"}";
            } else {
                queryString = "is_published=true&section.cod=" + section + "&populate=section.page.cod&sort={\"field\":\"order\",\"dir\":\"asc\"}";
            }

            // Get all sections
            const response = await api.getAllItems("section", queryString);

            if (response instanceof Error) {
                // Do not continue
                return;
            }

            this.pageSections = response;

            if (this.pageSections.length === 0) {
                // Invalid page/section combination, return to the public home page.
                this.loading = false;
                this.redirectToHome();
                return;
            }

            this.page = this.pageSections[0]["section"] ? this.pageSections[0]["section"]["page"] : this.pageSections[0]["page"];
            this.parentSection = this.pageSections[0]["section"];

            const sectionToFind = subsection ? subsection : section;

            // Search for the section
            const sectionIndex = this.pageSections.findIndex(x => x.cod === sectionToFind);

            this.selected = 0;
            if (sectionIndex < 0) {
                this.loading = false;
                this.redirectToHome();
                return;
            }

            if (sectionIndex >= 0) {
                this.selected = sectionIndex;
                this.selectedSection = this.pageSections[sectionIndex];
            }

            if (await this.redirectEmptyCorpusSectionToFirstChild(page, section, subsection)) {
                this.loading = false;
                return;
            }

            this.loading = false;
        }
    },
    components: {
        // Conversation
        [ConversationExplorer.name]: ConversationExplorer,
        [ConversationAdvancedAudio.name]: ConversationAdvancedAudio,
        [ConversationDetails.name]: ConversationDetails,
        [AnnotationDetails.name]: AnnotationDetails,
        [SpeechDetails.name]: SpeechDetails,
        [DialogDetails.name]: DialogDetails,
        [InterventionDetails.name]: InterventionDetails,
        [ActDetails.name]: ActDetails,
        [SubactDetails.name]: SubactDetails,
        [TokenDetails.name]: TokenDetails,
        [AdvancedSearch.name]: AdvancedSearch,
        [ChronologicSearch.name]: ChronologicSearch,

        // Letter
        [LetterExplorer.name]: LetterExplorer,
        [LetterViewer.name]: LetterViewer,
        [LetterSearch.name]: LetterSearch,

        // Member
        [MemberList.name]: MemberList,
        [Breadcrumb.name]: Breadcrumb
    }
}
</script>
<style>
#page-container {
    /*margin-top:130px !important;*/
    /* margin-top: 30px !important; */
    margin-bottom: 100px !important;
    /*background-color: red*/
}

/* For titles */
.headline {
    display: block;
    font-family: 'amaranth' !important;
    color: #da8d2b;
    text-shadow: 1px 1px 1px #eaf1ea;
    line-height: 120%;
}

.loading-page {
    height: calc(80vh - 48px - 72px);
}

.page_title {
    text-align: center;
    font-weight: 700 !important;
    font-size: 26px !important;
    margin: 0;
    padding: 0;
    padding-top: 10px;
    padding-bottom: 10px;
    /*                margin-block-start: 0.67em;
                        margin-block-end: 0.67em;*/
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

.section {
    /*background-color: red;*/
    width: 300px;
    height: 20px
}

/*    .section-option{
        color: #da8d2b;
        background-color: blue;
    }*/

.section_title {
    /*font-size: larger !important;*/
    font-weight: 400 !important;
    font-weight: bold !important;
    margin: 0;
    padding: 0 !important;
    display: block;
    font-family: 'amaranth' !important;
    color: #da8d2b;
    text-shadow: 1px 1px 1px #eaf1ea;
    line-height: 120%;
}

.v-list-item__content {
    padding: 6px 0 !important;
}

.v-list-item__title {
    white-space: normal !important;
    /*overflow: visible !important;*/
    font-size: 20px !important;
    line-height: 1.2 !important;
}

.section-content {
    padding: 15px;
}

.corpus-drawer-toggle {
    background-color: #da8d2b !important;
    left: 12px;
    position: fixed !important;
    top: 58px;
    z-index: 2600;
}

p {
    text-align: justify;
    font-family: 'Helvetica Neue,Helvetica,Arial,sans-serif';
    font-weight: 400;
    font-size: 100%;
    font-weight: 400;
    margin: 0 0 25px 0;
    line-height: 155%;
    color: #212121;
}

a {
    color: #da8d2b !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    color: #da8d2b;
    text-shadow: 1px 1px 1px #eaf1ea;
    margin: 15px 0 10px 0;
    font-weight: normal !important;
    line-height: 120%;
    font-family: 'amaranth';
}

.custom-color--text {
    color: #da8d2b !important;
    caret-color: #da8d2b !important;
}

#left-navigation-drawer a:not(.v-list-item--active) {
    color: rgba(0, 0, 0, .87) !important;
}
</style>
